module.exports = __webpack_public_path__ + "static/media/girl.243e62eb.jpg";